const kztFmt = new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 2 });
const intFmt = new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 0 });
const discFmt = new Intl.NumberFormat('ru-RU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const MONTHS_RU = ['Январь','Февраль','Март','Апрель','Май','Июнь','Июль','Август','Сентябрь','Октябрь','Ноябрь','Декабрь'];

export function useFormatters() {

  function fmtNum(n) {
    if (!n) return '0';
    const r = Math.round(n * 1000) / 1000;
    return r % 1 === 0 ? String(r) : String(r).replace('.', ',');
  }

  function fmtKzt(n) {
    if (n == null || isNaN(n)) return '0';
    return kztFmt.format(n);
  }

  function fmtInt(n) {
    if (n == null || isNaN(n)) return '0';
    return intFmt.format(n);
  }

  function fmtDisc(val) {
    if (val == null || val === 0) return '0';
    return discFmt.format(Number(val));
  }

  function fmtDiscDelta(val) {
    if (val == null || val === 0) return '0';
    const s = discFmt.format(Number(val));
    return val > 0 ? '+' + s : s;
  }

  function fmtIsoToRu(iso) {
    if (!iso) return null;
    const m = String(iso).match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!m) return null;
    return `${m[3]}.${m[2]}.${m[1]}`;
  }

  function fmtRange(fromIso, toIso) {
    const a = fmtIsoToRu(fromIso);
    const b = fmtIsoToRu(toIso);
    if (!a && !b) return '—';
    if (a && !b) return a;
    if (!a && b) return b;
    return a === b ? a : `${a}—${b}`;
  }

  function fmtDateRu(iso) {
    if (!iso) return '';
    const m = String(iso).match(/^(\d{4})-(\d{2})-(\d{2})/);
    return m ? `${m[3]}.${m[2]}.${m[1]}` : String(iso);
  }

  function fmtDateTimeRu(val) {
    if (!val) return '';
    const s = String(val);
    const m = s.match(/^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})/);
    if (m) return `${m[3]}.${m[2]}.${m[1]} ${m[4]}:${m[5]}`;
    return s;
  }

  function isoToDmy(iso) {
    if (!iso) return iso;
    const [y, m, d] = iso.split('-');
    return `${d}.${m}.${y}`;
  }

  function parseIso(iso) {
    if (!iso) return null;
    let m = String(iso).match(/^(\d{2})\.(\d{2})\.(\d{4})$/);
    if (m) {
      const [, d, mo, y] = m.map(Number);
      const dt = new Date(y, mo - 1, d);
      return dt.getFullYear() === y && dt.getMonth() === mo - 1 && dt.getDate() === d ? dt : null;
    }
    m = String(iso).match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!m) return null;
    const [, y, mo, d] = m.map(Number);
    const dt = new Date(y, mo - 1, d);
    return dt.getFullYear() === y && dt.getMonth() === mo - 1 && dt.getDate() === d ? dt : null;
  }

  function isoDate(dt) {
    return (
      dt.getFullYear() +
      '-' +
      String(dt.getMonth() + 1).padStart(2, '0') +
      '-' +
      String(dt.getDate()).padStart(2, '0')
    );
  }

  function round6(val) {
    const n = parseFloat(val);
    return isNaN(n) ? val : parseFloat(n.toFixed(6));
  }

  function r6(n) {
    return Math.round(parseFloat(n) * 1e6) / 1e6;
  }

  function parseFactNum(val) {
    if (val == null || val === '') return 0;
    if (typeof val === 'number' && Number.isFinite(val)) return val;
    let s = String(val).trim().replace(/\u00a0/g, '').replace(/\s/g, '');
    if (!s) return 0;
    const commas = (s.match(/,/g) || []).length;
    const dots   = (s.match(/\./g) || []).length;
    if (commas === 1 && dots === 0) s = s.replace(',', '.');
    else if (commas >= 1 && dots >= 1) {
      s = dots > commas
        ? s.replace(/,/g, '')
        : s.replace(/\./g, '').replace(',', '.');
    } else if (commas > 1 && dots === 0) s = s.replace(/,/g, '');
    const n = parseFloat(s);
    return Number.isFinite(n) ? r6(n) : 0;
  }

  function discDeltaClass(val) {
    if (!val || Math.abs(val) <= 1) return 'text-grey-6';
    return val > 0 ? 'text-green-8' : 'text-red-8';
  }

  function discRowClass(r) {
    if (r.source === 'only_ours') return 'disc-row-only-ours';
    if (r.source === 'only_usp') return 'disc-row-only-usp';
    if (r.has_discrepancy) return 'disc-row-diff';
    return 'disc-row-ok';
  }

  function discPeriodLabel(iso) {
    if (!iso) return '—';
    const [y, m, d] = iso.substring(0, 10).split('-');
    return d + '.' + m + '.' + y;
  }

  function discFmtDate(iso) {
    if (!iso) return '—';
    const s = iso.substring(0, 10);
    const [y, m, d] = s.split('-');
    return d + '.' + m + '.' + y;
  }

  function discFmtDateTime(iso) {
    if (!iso) return '—';
    const s = iso.substring(0, 10);
    const [y, m, d] = s.split('-');
    const time = iso.length > 10 ? iso.substring(11, 16) : '';
    return d + '.' + m + '.' + y + (time ? ' ' + time : '');
  }

  return {
    fmtNum,
    fmtKzt,
    fmtInt,
    fmtDisc,
    fmtDiscDelta,
    fmtIsoToRu,
    fmtRange,
    fmtDateRu,
    fmtDateTimeRu,
    isoToDmy,
    parseIso,
    isoDate,
    round6,
    r6,
    parseFactNum,
    discDeltaClass,
    discRowClass,
    discPeriodLabel,
    discFmtDate,
    discFmtDateTime,
  };
}
